<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="eye-show"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path id="Path_1485" data-name="Path 1485" d="M0,0H24V24H0Z" fill="none" />
    <path
      id="Path_1486"
      data-name="Path 1486"
      d="M3.118,12.467a.987.987,0,0,1,0-.935C5.01,8.033,8.505,5,12,5s6.99,3.033,8.882,6.533a.987.987,0,0,1,0,.935C18.99,15.967,15.495,19,12,19S5.01,15.967,3.118,12.467Z"
      fill="none"
      :stroke="clr ? clr : '#56606B'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      id="Path_1487"
      data-name="Path 1487"
      d="M14.121,9.879a3,3,0,1,1-4.243,0,3,3,0,0,1,4.243,0"
      fill="none"
      :stroke="clr ? clr : '#56606B'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.429"
    />
  </svg>
</template>
